import PciOtpScreen from "pages/PciOtpScreen";
import Address from "../../pages/Address";
import NotFound from "../../pages/NotFound";
import Payment from "../../pages/Payment/mobile";
import PaymentSuccess from "../../pages/PaymentSuccess";
import PrePaymentSuccess from "../../pages/PrePaymentSuccess";
import SimplOtpScreen from "../../pages/SimplOtpScreen";
import PaymentStatus from "../../pages/PaymentStatus";
import PostPayment from "../../pages/PostPayment";
import PaymentPreConfirmation from "../../pages/PaymentPreConfirmation";
import MySavedPayment from "../../pages/MySavedPayment/mobile";
import InitiateRoutes from "../../pages/index"
import ExpressCheckout from "../../pages/ExpressCheckout";
import GiftcardStatus from "pages/GiftcardStatus";
import { SavedAddressPage } from "pages/SavedAddresses";
import { NewAddresspage } from "pages/NewAddress";
import { ImportAddressPage } from "pages/ImportAddress";
import { CLIENT_URLS } from "constants/urls";
import { CheckoutPayment } from "layouts/CheckoutPayment/mobile";
import { ExpressCheckoutPayment } from "layouts/ExpressCheckoutPayment/mobile";
import { InterMediateScreen } from "layouts/AutoOrder/InterMediateScreen";

export const mobileRoutes = [
  {
    path: [CLIENT_URLS.BASE_URL],
    component: InitiateRoutes,
    routes: [
      /**
       * payment routes
       */
      {
        path: [CLIENT_URLS.PAYMENT_BASE_URL],
        component: Payment,
        routes:[
          {
            path: [CLIENT_URLS.PAYMENT_BASE_URL],
            component: CheckoutPayment,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PCI_OTP_PAGE],
            component: PciOtpScreen,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PAYMENT_PRE_CONFIRMATION_PAGE],
            component: PaymentPreConfirmation,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.POST_PAYMENT_PAGE],
            component: PostPayment,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PAYMENT_SUCCESS_PAGE],
            component: PaymentSuccess,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.MY_SAVED_PAYMENT_PAGE],
            component: MySavedPayment,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.SIMPL_OTP_PAGE],
            component: SimplOtpScreen,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PRE_PAYMENT_SUCCESS_PAGE],
            component: PrePaymentSuccess,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.SIMPL_PAYMENT_STATUS_PAGE + '/:status'],
            component: PaymentStatus,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.GIFTCARD_PAYMENT_STATUS_PAGE],
            component: GiftcardStatus,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.AUTO_ORDERS],
            component: InterMediateScreen,
            footer: true,
            exact: true,
          },
          {
            path: '*',
            component: NotFound,
            status: 404,
          },
        ],
        footer: true,
      },
      /**
       * Address routes
       */
      {
        path: [CLIENT_URLS.ADDRESS_BASE_URL],
        component: Address,
        routes:[
          {
            /**
             * The wildcard (*) is used in the path to allow for any nested routes or dynamic segments.
             * under `${CLIENT_URLS.NEW_ADDRESS}` to be matched. This ensures that components like 
             * NewAddressPage can handle paths with query param on client side redirection such as `/v2/address/new?src=importPage`
             * or any other dynamic route extension.
             */
            path: [`${CLIENT_URLS.NEW_ADDRESS}*`],
            component: NewAddresspage,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.SAVED_ADDRESS],
            component: SavedAddressPage,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.EDIT_ADDRESS],
            component: NewAddresspage,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.IMPORT_ADDRESS],
            component: ImportAddressPage,
            footer: true,
            exact: true,
          },
          {
            path: '*',
            component: NotFound,
            status: 404,
          },
        ],
        footer: true,
      },
      /**
       * Express Checkout routes
       */
      {
        path: [CLIENT_URLS.EXPRESS_CHECKOUT_BASE_URL],
        component: ExpressCheckout,
        routes:[
          {
            path: [CLIENT_URLS.EXPRESS_CHECKOUT_PAYMENT_URL],
            component: ExpressCheckoutPayment,
            footer: true,
            exact: true,
          },
          {
            path: '*',
            component: NotFound,
            status: 404,
          },
        ],
        footer: true,
      },
      {
        path: '*',
        component: NotFound,
        status: 404,
      },
    ],
    footer: true,
  },
  {
    path: '*',
    component: NotFound,
    status: 404,
  },
];
